import { signal } from "@preact/signals-react";
import { Button } from "@progress/kendo-react-buttons";
import { Editor, EditorTools } from "@progress/kendo-react-editor";

const { Bold, Italic, Underline, OrderedList, UnorderedList } = EditorTools;

export const FieldInformationProperty = {
  propertyName: "FieldInformation",
  propertyDisplay: "Field Information",
  propertyType: "richtext",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    const propValue = signal(currentPropertyValues?.[this.propertyName] ?? "<p></p>");

    const handleClearEditor = () => {
      propValue.value = "<p></p>";

      handlePropertyChange({
        propName: this.propertyName,
        propValue: propValue.value,
      });
    };

    const handleMouseEnter = (e) => {
      e.target.focus();
    };

    return (
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "8px",
          width: "95%",
        }}
      >
        <Editor
          defaultContent={currentPropertyValues?.[this.propertyName] ?? "<p></p>"}
          tools={[[Bold, Italic, Underline, OrderedList, UnorderedList]]}
          contentStyle={{ height: 200, width: "100%" }}
          onChange={(e) => {
            propValue.value = e.html;
          }}
          onBlur={() => {
            handlePropertyChange({
              propName: this.propertyName,
              propValue: propValue.value,
            });
          }}
          defaultEditMode="div"
        />
        <div
          style={{
            marginBottom: "-5px",
            marginTop: "3px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            style={{ fontSize: "14px" }}
            themeColor={"primary"}
            size={"medium"}
            onClick={handleClearEditor}
            onMouseEnter={handleMouseEnter}
          >
            Clear Text
          </Button>
        </div>
      </div>
    );
  },
};
